import { useMemo } from 'react'
import { useNodes, useEdges } from 'reactflow'
import { useWorkflow } from '@/lib/contexts/workflow-context'
import { resolveWorkflowGraphForVariableDiscovery } from '@/lib/workflowFormFieldVariables'

/**
 * Graph snapshot for upstream HTTP/form variable discovery in workflow builder nodes.
 * Uses the live React Flow canvas when mounted, with workflow-context fallback.
 */
export function useWorkflowGraphForVariableDiscovery(workflowId) {
  const liveNodes = useNodes()
  const liveEdges = useEdges()
  const { currentWorkflow, workflows } = useWorkflow()

  const resolvedWorkflowId = workflowId ?? currentWorkflow?.id
  const contextWorkflow =
    workflows.find((workflow) => workflow.id === resolvedWorkflowId) ??
    (currentWorkflow?.id === resolvedWorkflowId ? currentWorkflow : null)

  const contextNodes = contextWorkflow?.nodes ?? []
  const contextEdges = contextWorkflow?.edges ?? []

  return useMemo(
    () =>
      resolveWorkflowGraphForVariableDiscovery(
        liveNodes,
        liveEdges,
        contextNodes,
        contextEdges,
      ),
    [liveNodes, liveEdges, contextNodes, contextEdges],
  )
}
